<template>
  <div class="wrapper">
    <div class="title">{{ title }}</div>
    <span class="fake-checkbox">
      <input type="checkbox" name="" :id="uid" v-model="check" />
      <label :for="uid"></label>
    </span>
  </div>
</template>

<script>
import { store } from "@/store/scene.js";
export default {
  name: "Checkbox",
  components: {},
  props: ["id", "title", "prop"],
  data() {
    return {
      check: false,
      store,
    };
  },
  mounted() {
    if (store[this.prop]) this.check = store[this.prop];
  },
  computed: {
    uid() {
      return this.id ? this.id : `chk_${this._uid}`;
    },
  },
  watch: {
    check(newVal, oldVal) {
      if (newVal !== oldVal) store[this.prop] = this.check;
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 2rem;
  letter-spacing: -0.6px;
}
.fake-checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
input {
  position: absolute;
  cursor: pointer;
  visibility: hidden;
}
label {
  display: inline-flex;
  width: calc(4rem - 4px);
  height: calc(4rem - 4px);
  border: 1px solid;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  transform: translateX(-2px);
}
input:checked ~ label:after {
  content: "";
  width: 50%;
  height: 50%;
  background: white;
}
</style>